module.exports = __webpack_public_path__ + "img/mawyc.4dbf0ad7.jpg";